import { ManagedIntegrationList } from '@frontend/api';

import { JOBBOSS2 } from 'modules/settings/integrations/eci/constants';
import { FUSION_INTEGRATION_DEFAULTS } from 'modules/settings/integrations/fusionTeams/constants';
import { DEFAULT_INTEGRATION_NAME } from 'modules/settings/integrations/managedIntegrations/constants';

export const isDefaultIntegration = (integration: ManagedIntegrationList) => {
  return (
    integration.integrationTemplateId != null &&
    integration.name === DEFAULT_INTEGRATION_NAME
  );
};

export const isJobBOSS2Integration = (
  managedIntegration: ManagedIntegrationList,
) => managedIntegration.integratedSoftwareName === JOBBOSS2;

export const isFusionIntegration = (
  managedIntegration: ManagedIntegrationList,
) => {
  return (
    managedIntegration.isCoreProductControlled &&
    managedIntegration.internalProductizedName ===
      FUSION_INTEGRATION_DEFAULTS.INTERNAL_PRODUCTIZED_NAME
  );
};
